import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment/moment';
import { Modal } from 'ngx-modal';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { MonthPipe } from '../../common/pipes/month.pipe';
import { TranslateKey } from '../../common/pipes/translate-key.pipe';
import { MemberActivityLogType } from '../../shared/common/enumerations';
import { Member } from '../../shared/interface/member.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { Utils } from '../../shared/Utils/utils';
import { IsoCodeThree } from '../common/constants';
import { DateConstants } from '../constants/date.constants';
import { ReportNameConstants } from '../constants/report-names.constants';
import { FLP360ReportNameConstants, ReportPathConstants, ReportTypeConstants } from '../constants/report-type.constants';
import { Translations } from '../constants/translations.constants';
import { MemberTitleExtEnums } from '../enums/member-title.enum';
import { Months } from '../enums/months.enum';
import { ActivityLogKey } from '../interface/activityLogKey';
import { CCSnapshot, CCSnapshotMonthlyValues } from '../interface/cc-snapshot';
import { ChairmanBonusIncentiveDetails, ChairmanBonusQualifiers } from '../interface/chairman-bonus-incentive-details';
import { CountryList } from '../interface/country-data';
import { EagleManagersIncentiveDetails, EagleManangerQualifiers } from '../interface/eagle-manager-incentives-details';
import { EarnedIncentiveDetails } from '../interface/earned-incentive-details';
import { FirstGenerationGemDetails, GemBonusIncentiveDetails, SilverCCGemManager } from '../interface/gem-bonus-incentive-details';
import { GlobalRallyIncentiveDetails, NextLevelRewardsDetails, RewardsAchievedDetails } from '../interface/global-rally-incentive-details';
import { IncentiveDetailsResponse } from '../interface/incentives-details.interface';
import { LeadershipBonusIncentiveDetails } from '../interface/leadership-bonus-incentive-details';
import { SpinnerService } from '../services/spinner.service';
import { IncentiveReportService } from '../services/view-incentives.service';

@Component({
    selector: 'app-incentives',
    templateUrl: '../templates/template1/views/incentives.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/downline-map.component.less',
        '../templates/template1/themes/default/css/incentives.component.less',
        '../templates/template1/themes/default/css/view-incentives.component.less'
    ],
    providers: [IncentiveReportService, MonthPipe]
})
export class IncentivesComponent implements OnInit {
    @Input() fboid: string;
    @Input() homeCountryInfo: string;
    @Input() operatingCountryInfo: string;
    @ViewChild('caseCreditsdetails') caseCreditsDetailsModalPopup: Modal;
    isLoading = false;
    _id: string;
    yearRange = [];
    homeCountry: string;
    errormessage: boolean;
    countries: CountryList[] = [];
    ccSnapshotMonthlyValues: any = [];
    data: any;
    bonusRecapRequest: Subscription;
    country: string;
    currentMonthCCValues: CCSnapshotMonthlyValues;
    previousMonthCCValues: CCSnapshotMonthlyValues;
    previous2MonthCCValues: CCSnapshotMonthlyValues;
    previous3MonthCCValues: CCSnapshotMonthlyValues;
    managerCountPercentage: number;
    totalCCPercentage = 0;
    requiredTotalCC: number;
    currentMonthLevel1Percentage: number;
    currentMonthLevel2Percentage: number;
    currentMonthLevel3Percentage: number;
    previousMonthLevel1Percentage: number;
    previousMonthLevel2Percentage: number;
    previousMonthLevel3Percentage: number;
    previous2MonthLevel1Percentage: number;
    previous2MonthLevel2Percentage: number;
    previous2MonthLevel3Percentage: number;
    managerCount: number;
    managerGoal: number;
    processingYear: number;
    filterOptionType: ReportTypeConstants;
    isPreviousYear = 0;
    isNextYear = 1;
    year = new Date().getFullYear();
    isMonth = new Date().getMonth() + 1;
    eagleManagerDate: string;
    yearFilterValue: number;
    caseCreditsDetails: CCSnapshotMonthlyValues;
    remainingGoal: number;
    isCurrentYear = true;
    disableNextYear = false;
    badEagleManagerData = true;
    ccSnapshot: CCSnapshot;
    month: any = [];
    countryAll: { name: string; value: string; };
    userName: string;
    selectedOption: boolean;
    currentYearCCValues = {
        personalCCMtd: '0', distributorCCMtd: '0', totalactiveCCMtd: '0',
        nonmanagerCCMtd: '0', leaderCC: '0', totalCCMtd: '0'
    };
    mydate: string;
    currentYear: number;
    currYear: number = new Date().getFullYear();
    preYear: number;
    pre2Year: number;
    pre3Year: number;
    currMonth: number = new Date().getMonth() + 1;
    preMonth: number;
    pre2Month: number;
    pre3Month: number;
    curruMonth: string;
    prevMonth: string;
    prev2Month: string;
    prev3Month: string;
    selectedCountry: any = [];
    value = 50;
    userInfo: any;
    currentMonth: number;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    eagleManagerCurrentMonth: number;
    ViewReportsPermission: any[] = [
        Permission.FBO_REPORTS_VIEW
    ];
    reportsCdnUrl = 'portals/customercare/reports';

    /*Related to User Details*/
    userDetails: Member;
    distributorId: string;

    /*Related to Countries Data*/
    operatingCountry: string;
    homeCountryName: string;
    countryList: CountryList[] = [];
    isCountryList: boolean;
    isCountryListLoaded: boolean;
    countryDisplayName: string;

    isEagleManagerQualified: boolean;
    eagleManagerTotalCC: number;
    eagleManagerGlobalCC: number;
    eagleManagerGlobalPercentage: number;
    eagleManagerMonth: string;
    eagleManagerTotalPercentage: number;
    // enableTrainingPopup = environment.enableTrainingPopup;
    // trainingSlugName = TrainingSlugNames.FLP360_INCENTIVES_REPORT;
    // trainingUrl = TrainingSlugUrl.FLP360_INCENTIVES_REPORT;
    // category = TrainingCategory.REPORTS;
    /* Get Incentives Reponse model for different reports*/
    getIncentivesGlobalRallyResponse: IncentiveDetailsResponse;
    getIncentivesEarnedResponse: IncentiveDetailsResponse;
    getIncentivesEagleManagerResponse: IncentiveDetailsResponse;
    getIncentivesLeadershipBonusResponse: IncentiveDetailsResponse;
    getIncentivesChairmanBonusResponse: IncentiveDetailsResponse;
    getIncentivesGemBonusResponse: IncentiveDetailsResponse;

    /*Passing Current year and month for various report */
    currentIncentivesYear = new Date().getFullYear().toString();
    currentIncentivesMonth = new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1).toString();
    earnedCurrentYear = this.currentIncentivesYear;
    globalRallyCurrentYear = this.currentIncentivesYear;
    earnedIncentivesYear = this.currentIncentivesYear;
    earnedCurrentDate = new Date();
    earnedCurrentMonth = new Date().getMonth() + 1;
    earnedPreviousMonths = this.earnedCurrentMonth - 1;
    earnedPrevious2Months = this.earnedCurrentMonth - 2;
    earnedIncentiveMonth = this.earnedCurrentMonth;
    currentYears = new Date().getFullYear().toString();
    earnedPreviousYears = (Number(this.currentYears) - 1).toString();
    earnedBeforeYears = (Number(this.currentYears) - 2).toString();
    earnedPreviousYear = (Number(this.currentIncentivesYear) - 1).toString();
    earnedBeforeYear = (Number(this.currentIncentivesYear) - 2).toString();
    earnedMonth1Year = new Date();
    earnedMonth2Year = new Date();
    earnedPreviousMonthYear = new Date(this.earnedMonth1Year.setMonth(this.earnedCurrentDate.getMonth() - 1)).getFullYear().toString();
    earnedPrevious2MonthYear = new Date(this.earnedMonth2Year.setMonth(this.earnedCurrentDate.getMonth() - 2)).getFullYear().toString();
    eagleManagerCurrentYear = (Number(this.currentIncentivesYear) - 1);
    eagleManagerPreviousYear = (Number(this.eagleManagerCurrentYear) - 1);
    eagleManagerNewCurrentYear = (Number(this.eagleManagerCurrentYear) + 1);
    eagleManagerNewPreviousYear = this.eagleManagerCurrentYear;
    eagleManagersCurrentMonth = new Date().getMonth() + 1;
    showNewEagleManagerYear = this.eagleManagersCurrentMonth <= 4;
    eagleManagersYear = new Date().getFullYear();
    eagleManagerCount = 0;
    leadershipCurrentMonth = this.currentIncentivesMonth;
    chairmanCurrentYear = this.currentIncentivesYear;
    gemBonusCurrentMonth = this.currentIncentivesMonth;

    /*Get individual incentives data*/
    getGlobalRally: GlobalRallyIncentiveDetails;
    getEarnedIncentives: EarnedIncentiveDetails;
    getEagleManagers: EagleManagersIncentiveDetails;
    getLeadershipBonus: LeadershipBonusIncentiveDetails;
    getChairmanBonus: ChairmanBonusIncentiveDetails;
    getGemBonus: GemBonusIncentiveDetails;

    /*Used in getting years data for various report */
    globalRallyYear: string[] = [];
    leadershipMonth: string[] = [];
    chairmanBonusYear: string[] = [];
    gemBonusMonth: string[] = [];

    /*Verifying the data is loaded */
    isGlobalRallyData = false;
    isEarnedData = false;
    isEagleManagerData = false;
    isLeadershipData = false;
    isChairmanData = false;
    isGemBonusData = false;


    /*Handling Error*/
    globalRallyError = false;
    earnedIncentiveError = false;
    eagleManagerError = false;
    leadershipError = false;
    chairmanBonusError = false;
    gemBonusError = false;

    /*No Record Flag*/
    globalRallyFlag = false;
    earnedIncentivesFlag = false;
    eagleManagerFlag = false;
    leadershipFlag = false;
    chairmanBonusFlag = false;
    gemBonusFlag = false;

    /*Related to Global Rally Incentives*/
    getGlobalRallyRewards: RewardsAchievedDetails[] = [];
    getGlobalRallyNextLevelRewards: NextLevelRewardsDetails[] = [];

    /*Related to Eagle Manager Incentives*/
    getEagleManagerQualifiers: EagleManangerQualifiers[] = [];
    eagleManagerQualifierCount: boolean;

    /*Related to chairman bonus incentives*/
    getChairmanBonusQualifiers: ChairmanBonusQualifiers[] = [];
    CBQualifierCount = false;
    displayChairmanBonus = false;

    /*Related to Gem Bonus Incentives*/
    silverCCGemManager: SilverCCGemManager[] = [];
    firstGenerationGemDetails: FirstGenerationGemDetails[] = [];
    displayFirstGemManager = false;
    displaySilverGemManager = false;

    isServerError: boolean;
    isNextLevelRewards = false;
    isNextRewards = false;
    currentLevel = false;
    isYearValid1 = false;
    isYearValid2 = false;
    displayFBODetails = false;

    firstDisplayMonth: number;
    displayMonth = new Date().getMonth() + 1;
    ytd:any;
    enableFLP360ReportPage: Boolean = false;
    displayRecap : boolean;
    operatingCountryName: string;

    constructor(
        private _commonService: CommonService,
        private _datePipe: DatePipe,
        private router: Router,
        private _decimalPipe: DecimalPipe,
        private _cacheService: CacheService,
        private _translatePipe: TranslateService,
        private _translateKey: TranslateKey,
        private _incentiveService: IncentiveReportService,
        private spinnerService: SpinnerService,
    ) { }

    ngOnInit(): void {
        // this.userInfo = this._cacheService.get(CacheKey.UserInfo);

        this.currentYear = new Date().getFullYear();
        this.homeCountry = this.homeCountryInfo;
        this.operatingCountry = this.homeCountryInfo;
        this.operatingCountryName = this.operatingCountryInfo;
        this._id = this.fboid;
        this.disableNextYear = false;
        const currentDate = new Date();
    for (let i = 0 ; i< 2; i++) {
      currentDate.setDate(-1);
      const selectedDate = currentDate.getMonth() + 1;
      if (i === 0) {
        this.earnedPreviousMonths =  selectedDate;
      } else  {
        this.earnedPrevious2Months = selectedDate;
      }
    }
        // this.eagleManagerDefaultDate = this.eagleManagerDate.getFullYear()+'-'+(this.eagleManagerDate.getMonth()+1)+'-'+this.eagleManagerDate.getDate();
        this.eagleManagerDate = this._datePipe.transform(new Date(), 'yyyy-MM-dd');
        this.mydate = this._datePipe.transform(new Date(), 'dd-MMM-yyyy');
        // this.mydate = this._datePipe.transform(new Date(), 'dd-MMM-yyyy');
        // this.userName = this.userInfo['firstName'] + " " + this.userInfo['lastName'];
        this.ccSnapshot = new CCSnapshot();
        this.getMonths();
        if (this.homeCountry !== '' && this.homeCountry != null) {
            this.getCountries(this._id, this.homeCountry);
        }
        this.getLastFourMonths();

        this.enableFLP360ReportPage = environment.enableFLP360ReportPage;
        this.saveMemberActivityLog();
    }

    /**
     * @description
     * @date 2019-09-09
     * @memberof IncentivesComponent
     */
    getLastFourMonths() {
        this.currentYear = new Date().getFullYear();
        this.processingYear = this.currentYear;
        const currentMonth = new Date().getMonth() + 1;
        this.currentMonth = currentMonth;
        this.month.push(moment((currentMonth - Months.March) === 0 ? Months.December :
            (currentMonth - Months.March) === -1 ? Months.November : (currentMonth - Months.March), 'MM' || 'M').format('MMM'));
        this.month.push(moment((currentMonth - Months.February) === 0 ? Months.December :
            (currentMonth - Months.February) === -1 ? Months.November : (currentMonth - Months.February), 'MM' || 'M').format('MMM'));
        this.month.push(moment((currentMonth - Months.January) === 0 ? Months.December :
            (currentMonth - Months.January), 'MM' || 'M').format('MMM'));
        this.month.push(moment(currentMonth, 'MM' || 'M').format('MMM'));
    }

    getMonths() {

        this.preYear = this.currMonth - 1 === 0 ? this.currYear - 1 : this.currYear;

        this.pre2Year = this.currMonth - 2 === 0 ? this.currYear - 1 : this.currMonth - 2 === -1 ? this.currYear - 1 : this.currYear;

        this.pre3Year = this.currMonth - 3 === -2 ? this.currYear - 1 :
            this.currMonth - 3 === -1 ? this.currYear - 1 :
                this.currMonth - 3 === 0 ? this.currYear - 1 : this.currYear;

        this.preMonth = this.currMonth - 1 === 0 ? 12 : this.currMonth - 1;
        this.pre2Month = this.currMonth - 2 === 0 ? 12 : this.currMonth - 2 === -1 ? 11 : this.currMonth - 2;
        this.pre3Month = this.currMonth - 3 === 0 ? 12 :
            this.currMonth - 3 === -1 ? 11 :
                this.currMonth - 3 === -2 ? 10 :
                    this.currMonth - 3;

                    this.curruMonth = moment(this.currMonth,'MM' || 'M').format('MMM');
                    this.prevMonth = moment(this.preMonth,'MM' || 'M').format('MMM');
                    this.prev2Month = moment(this.pre2Month,'MM' || 'M').format('MMM');
                    this.prev3Month = moment(this.pre3Month,'MM' || 'M').format('MMM');

    }


    setYear() {
        this.eagleManagerCurrentMonth = new Date().getMonth() + 1;

        const date: number = new Date().getFullYear();
        if (this.year === 2018 && this.eagleManagerCurrentMonth >= 5) {
            this.eagleManagerDate = Utils.convertToSpecificDateFormat(new Date(date, 4, 30), DateConstants.DOBFormat);
        } else if (this.year === 2018) {
            this.eagleManagerDate = Utils.convertToSpecificDateFormat(new Date(date - 1, 4, 30), DateConstants.DOBFormat);
        } else {
            this.eagleManagerDate = Utils.convertToSpecificDateFormat(new Date(), DateConstants.DOBFormat);
        }
        // Date.newInstance(Date.today().addYears(-1).year(), 4, 30);
    }

    openPDF(url: string) {
        window.open(url, '_blank', '');
        window.focus();
    }

    /**
     * @description
     * @date 2019-09-16
     * @memberof IncentivesComponent
     */
    viewPreviousYearData() {
        this.isPreviousYear++;
        if (this.isPreviousYear === 1 && this.processingYear > this.currentYear - 4) {
            this.processingYear = this.processingYear - 1;
            this.getYearlyCaseCreditsDetails(this.processingYear);
            this.isPreviousYear--;
        } else {
            this.processingYear = this.currentYear;
            this.getYearlyCaseCreditsDetails(this.processingYear);
        }
        if (this.processingYear === this.currentYear - 4) {
            this.disableNextYear = true;
            this.isCurrentYear = false;
        } else {
            this.disableNextYear = false;
            this.isCurrentYear = false;
        }

    }

    /**
     * @description
     * @date 2019-09-16
     * @memberof IncentivesComponent
     */
    viewNextYearData() {
        this.isNextYear--;
        //  if(this.processingYear === this.currentYear){
        //     this.processingYear = this.currentYear-4;
        //     this.getYearlyCaseCreditsDetails(this.processingYear);
        //     this.isNextYear++;
        //  }
        // else
        if (this.isNextYear === 0 && this.processingYear < this.currentYear) {
            this.processingYear = this.processingYear + 1;
            this.getYearlyCaseCreditsDetails(this.processingYear);
            this.isNextYear++;
        } else {
            this.processingYear = this.currentYear;
            this.getYearlyCaseCreditsDetails(this.processingYear);
        }
        if (this.processingYear < this.currentYear) {
            this.isCurrentYear = false;
        } else {
            this.isCurrentYear = true;
        }
    }

    /**
* changeCountry Method used to get the downlines data based on country selected
* @param  {string} country
* @returns void
*/
    changeCountry(country: string): void {
        // this.isDetailsOpened = false;
        this.country = country;
        this.selectedOption = false;
        this.getCCSnapshotInfo(this._id, this.country);
        this.getGlobalRallyResponse();
        // this.getEarnedIncentivesData(this.earnedCurrentYear);
        this.getEarnedIncentivesData(this.earnedCurrentYear, this.earnedCurrentMonth);
        this.getEagleManagerByYearIncentivesData(this.eagleManagerCurrentYear);
        this.getLeadershipBonusResponse();
        this.getChairmanBonusResponse();
        this.getGemBonusReponse();
    }

    /**
    * getCountries Method used to get the country list
    * @param  {number} distributorId
    * @returns void
    */
    getCountries(distributorId: string, homeCountryInfo: string): void {
        // this._loader.show();
        // this._customerService
        // this._loader.show();
        if (this.displayMonth > 4) {
            /*Sending Year*/
            this.eagleManagerCurrentYear = new Date().getFullYear();
            this.eagleManagerPreviousYear = (Number(this.eagleManagerCurrentYear) - 1);
            /*display Year*/
            this.eagleManagerNewCurrentYear = (Number(this.currentYear) + 1);
            this.eagleManagerNewPreviousYear = this.eagleManagerCurrentYear;
            this.eagleManagersYear = Number(this.currentYear);
        }
        this._commonService
            .getCountries(distributorId, homeCountryInfo)
            .subscribe(res => {
                if (res) {
                    res.forEach((element: any) => {
                        const country: CountryList = { name: '', value: '' };
                        if (this.countries.length === 0) {
                            this.countryAll = { name: 'Global', value: 'null' };
                            this.countries.push(this.countryAll);
                        }
                        country.name = element.countryName;
                        country.value = element.operatingCompany;
                        if (element.homeCountry === true || element.homeCountry === 'true') {
                            this.selectedCountry = country;
                            this.country = this.selectedCountry.value;
                        }
                        this.countries.push(country);
                    }
                    );
                    if (this._commonService.checkPermissionByAccessLevel(this.ViewReportsPermission, AccessLevel.Customer_Service)) {
                        this.getCCSnapshotInfo(this._id, this.country);
                        this.getGlobalRallyResponse();
                        // this.getEarnedIncentivesData(this.earnedCurrentYear);
                        this.getEarnedIncentivesData(this.earnedCurrentYear, this.earnedCurrentMonth);
                        this.getEagleManagerByYearIncentivesData(this.eagleManagerCurrentYear);
                        this.getLeadershipBonusResponse();
                        this.getChairmanBonusResponse();
                        this.getGemBonusReponse();
                    }
                }
            },
                error => {
                    this.errormessage = true;
                    console.error(error);
                });
    }

    /**
     * @description
     * @date 2019-09-09
     * @memberof IncentivesComponent
     */
    getCCSnapshotInfo(distributorId: string, country: string): void {
        this.isLoading = true;
        this._commonService
            .getCCSnapshotDetails(this._id, country)
            .subscribe(response => {
                if (response) {

                    this.ccSnapshotMonthlyValues = response[0].monthlyCCValues;
                    this.managerCountPercentage = (response[0].managerCount / response[0].currentManagerGoal) * 100;
                    this.data = response[0].monthlyCCValues[0];
                    this.managerCount = response[0].managerCount;
                    this.managerGoal = response[0].currentManagerGoal;
                    this.remainingGoal = this.managerGoal - this.managerCount;
                    // this.currentMonthCCValues = this.setDefaultMonthValues(response[0].monthlyCCValues[0]);
                    // this.currentMonthCCValues = response[0].monthlyCCValues[0];
                    // this.ccSnapshot.globalCC = this.currentMonthCCValues.personalCCMtd;
                    this.assignPrevious3MonthlyValues(response[0].monthlyCCValues[0]);
                    this.assignPrevious2MonthlyValues(response[0].monthlyCCValues[1]);
                    this.assignPreviousMonthlyValues(response[0].monthlyCCValues[2]);
                    this.assignCurrentMonthlyValues(response[0].monthlyCCValues[3]);

                    this.ccSnapshot.totalGlobalCC = response[0].totalCC;
                    // this.ccSnapshot.nextLevel = response[0].nextLevel;
                    this.ccSnapshot.nextLevel = response[0].memberLevel;
                    this.ccSnapshot.totMgrCount = response[0].managerCount;

                }
            });

    }

    assignPreviousMonthlyValues(monthlyCCValues: CCSnapshotMonthlyValues) {

        this.previousMonthCCValues = {
            personalCCMtd: this.totalCCValues(monthlyCCValues.personalCCMtd),
            distributorCCMtd: this.totalCCValues(monthlyCCValues.distributorCCMtd),
            totalactiveCCMtd: this.totalCCValues(monthlyCCValues.totalactiveCCMtd),
            nonmanagerCCMtd: this.totalCCValues(monthlyCCValues.nonmanagerCCMtd),
            leaderCC: this.totalCCValues(monthlyCCValues.leaderCC),
            totalCCMtd: this.totalCCValues(monthlyCCValues.totalCCMtd),
            processingMonth: monthlyCCValues.processingMonth,
            processingYear: monthlyCCValues.processingYear,
            netMonthlyBonus: this.totalCCValues(monthlyCCValues.netMonthlyBonus),
            currentMonthActive: monthlyCCValues.currentMonthActive,
            endingLevel: monthlyCCValues.endingLevel
        };
    }

    assignCurrentMonthlyValues(monthlyCCValues: CCSnapshotMonthlyValues) {
        this.currentMonthCCValues = {
            personalCCMtd: this.totalCCValues(monthlyCCValues.personalCCMtd),
            distributorCCMtd: this.totalCCValues(monthlyCCValues.distributorCCMtd),
            totalactiveCCMtd: this.totalCCValues(monthlyCCValues.totalactiveCCMtd),
            nonmanagerCCMtd: this.totalCCValues(monthlyCCValues.nonmanagerCCMtd),
            leaderCC: this.totalCCValues(monthlyCCValues.leaderCC),
            totalCCMtd: this.totalCCValues(monthlyCCValues.totalCCMtd),
            processingMonth: monthlyCCValues.processingMonth,
            processingYear: monthlyCCValues.processingYear,
            netMonthlyBonus: this.totalCCValues(monthlyCCValues.netMonthlyBonus),
            currentMonthActive: monthlyCCValues.currentMonthActive,
            endingLevel: monthlyCCValues.endingLevel
        };
    }


    assignPrevious2MonthlyValues(monthlyCCValues: CCSnapshotMonthlyValues) {
        this.previous2MonthCCValues = {
            personalCCMtd: this.totalCCValues(monthlyCCValues.personalCCMtd),
            distributorCCMtd: this.totalCCValues(monthlyCCValues.distributorCCMtd),
            totalactiveCCMtd: this.totalCCValues(monthlyCCValues.totalactiveCCMtd),
            nonmanagerCCMtd: this.totalCCValues(monthlyCCValues.nonmanagerCCMtd),
            leaderCC: this.totalCCValues(monthlyCCValues.leaderCC),
            totalCCMtd: this.totalCCValues(monthlyCCValues.totalCCMtd),
            processingMonth: monthlyCCValues.processingMonth,
            processingYear: monthlyCCValues.processingYear,
            netMonthlyBonus: this.totalCCValues(monthlyCCValues.netMonthlyBonus),
            currentMonthActive: monthlyCCValues.currentMonthActive,
            endingLevel: monthlyCCValues.endingLevel
        };
    }

    assignPrevious3MonthlyValues(monthlyCCValues: CCSnapshotMonthlyValues) {
        this.previous3MonthCCValues = {
            personalCCMtd: this.totalCCValues(monthlyCCValues.personalCCMtd),
            distributorCCMtd: this.totalCCValues(monthlyCCValues.distributorCCMtd),
            totalactiveCCMtd: this.totalCCValues(monthlyCCValues.totalactiveCCMtd),
            nonmanagerCCMtd: this.totalCCValues(monthlyCCValues.nonmanagerCCMtd),
            leaderCC: this.totalCCValues(monthlyCCValues.leaderCC),
            totalCCMtd: this.totalCCValues(monthlyCCValues.totalCCMtd),
            processingMonth: monthlyCCValues.processingMonth,
            processingYear: monthlyCCValues.processingYear,
            netMonthlyBonus: this.totalCCValues(monthlyCCValues.netMonthlyBonus),
            currentMonthActive: monthlyCCValues.currentMonthActive,
            endingLevel: monthlyCCValues.endingLevel
        };
    }




    /**
    *
    *
    * @param {number} ccValue
    * @returns
    * @memberof DownlineMapComponent
    */
    totalCCValues(ccValue: Number) {

        let totalCCMonthValue;
        if (ccValue) {
            totalCCMonthValue = this._decimalPipe.transform(+(ccValue), '1.3-3');
        } else {
            totalCCMonthValue = '0.000';
        }
        return totalCCMonthValue;
    }


    /**
     * @description
     * @date 2019-09-09
     * @memberof IncentivesComponent
     */
    getYearlyCaseCreditsDetails(year?: number) {
        if (this._id && this.country) {
            if(!year) {
                this.currentYear=new Date().getFullYear();
                this.processingYear=this.currentYear;
                this.isCurrentYear=true;
                this.disableNextYear=false;
            }
            this._commonService
                .getYearlyCaseCreditsDetails(this._id, this.country, year)
                .subscribe(res => {
                    if (res) {
                        this.caseCreditsDetails = res;
                        if(this.year === year){
                            this.displayRecap = false;
                        }
                        else{
                            this.displayRecap = true;
                        }
                        this.getYTD(this.caseCreditsDetails);
                        this.caseCreditsDetailsModalPopup.open();
                    }
                });

        }
    }

    getYTD(caseCreditsDetails){
        let personalCCSum = 0;
        let newFBOCCSum = 0;
        let totalActiveCCSum = 0;
        let nonManagerCCSum = 0;
        let leaderShipCCSum = 0;
        let totalCCSum = 0;
        caseCreditsDetails.forEach(caseCreditElement => {
            personalCCSum = caseCreditElement.personalCCMtd + personalCCSum;
            newFBOCCSum   = caseCreditElement.distributorCCMtd + newFBOCCSum;
            totalActiveCCSum   = caseCreditElement.totalactiveCCMtd + totalActiveCCSum;
            nonManagerCCSum   = caseCreditElement.nonmanagerCCMtd + nonManagerCCSum;
            leaderShipCCSum   = caseCreditElement.leaderCC + leaderShipCCSum;
            totalCCSum   = caseCreditElement.totalCCMtd + totalCCSum;
        });
        this.ytd = {
            "personalCCSum" : personalCCSum,
            "newFBOCCSum" : newFBOCCSum,
            "totalActiveCCSum" : totalActiveCCSum,
            "nonManagerCCSum": nonManagerCCSum,
            "leaderShipCCSum": leaderShipCCSum,
            "totalCCSum": totalCCSum
        };
    }

    /**
   * getBonusRecapData method is used to fetch Bonus Recap PDF information changes
   * @param  {string} distributorId
   * @param  {string} country
   * @param  {number} month
   * @param  {number} year
   * @returns void
   */
    getBonusRecapData(month: number): void {
        this.bonusRecapRequest = this._commonService
            .getBonusRecapData(this._id, this.country, month, this.processingYear)
            .subscribe(res => {
                const bonusRecapPdf = new Blob([res._body], { type: 'application/pdf' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(bonusRecapPdf,
                        ReportTypeConstants.MYEARNINGS + this._id + '_' + this.country + '_' + this.processingYear + '_' + month + '.pdf');
                } else {
                    if (res) {
                        const blob = new Blob([res.blob()], { type: 'application/pdf' });
                        const fileURL = URL.createObjectURL(blob);
                        const newWin = window.open(fileURL, '_blank');
                        if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
                            alert(this._translateKey.transform(this._translatePipe.get(Translations.POP_UP_MESSAGE)['value'], false));
                        }
                    }
                }
            },
                error => {
                    console.error(error);
                    this.errormessage = true;
                    // this._loader.hide();
                });
    }

    getBonusRecap(month: number, year: number): void {
        this.bonusRecapRequest = this._commonService
            .getBonusRecapData(this._id, this.country, month, year)
            .subscribe(res => {
                const bonusRecapPdf = new Blob([res._body], { type: 'application/pdf' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(bonusRecapPdf,
                        ReportTypeConstants.MYEARNINGS + this._id + '_' + this.country + '_' + this.processingYear + '_' + month + '.pdf');
                } else {
                    if (res) {
                        const blob = new Blob([res.blob()], { type: 'application/pdf' });
                        const fileURL = URL.createObjectURL(blob);
                        const newWin = window.open(fileURL, '_blank');
                        if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
                            alert(this._translateKey.transform(this._translatePipe.get(Translations.POP_UP_MESSAGE)['value'], false));
                        }


                    }
                }
            },
                error => {
                    console.error(error);
                    this.errormessage = true;
                    // this._loader.hide();
                });
    }
    closePopUp = () => {
        this.caseCreditsDetailsModalPopup.close();
    }

/**
* @description Get Global Rally Incentives Response
* @memberof IncentivesComponent
*/
    getGlobalRallyResponse() {
        setTimeout(() => {
            this.spinnerService.start(ReportNameConstants.GLOBAL_RALLY);
        }, 0);
        this.globalRallyFlag = true;
        this._incentiveService.getIncentivesDetails(this._id, this.country, ReportNameConstants.GLOBAL_RALLY)
            .subscribe((data) => {
                this.getIncentivesGlobalRallyResponse = data;
                this.isGlobalRallyData = true;
                this.globalRallyError = false;
                this.getGlobalRallyRewards = [];
                this.getGlobalRallyNextLevelRewards = [];
                this.globalRallyYear = [];
                if (this.getIncentivesGlobalRallyResponse.globalRallyView.length <= 0) {
                    this.globalRallyFlag = false;
                } else {
                    this.globalRallyFlag = true;
                }
                for (let i = 0; i < this.getIncentivesGlobalRallyResponse.globalRallyView.length; i++) {
                    if (this.getIncentivesGlobalRallyResponse.globalRallyView[i].year === this.globalRallyCurrentYear) {
                        this.getGlobalRally = this.getIncentivesGlobalRallyResponse.globalRallyView[i];
                        if (this.getGlobalRally.rewardsAchieved.length <= 0) {
                            this.isNextRewards = false;
                        } else {
                            for (let j = 0; j < this.getGlobalRally.rewardsAchieved.length; j++) {
                                this.getGlobalRallyRewards.push(this.getGlobalRally.rewardsAchieved[j]);
                            }
                            this.isNextRewards = true;
                        }
                        if (this.getGlobalRally.nextLevelRewards.length <= 0) {
                            this.isNextLevelRewards = false;
                        } else {
                            for (let k = 0; k < this.getGlobalRally.nextLevelRewards.length; k++) {
                                this.getGlobalRallyNextLevelRewards.push(this.getGlobalRally.nextLevelRewards[k]);
                            }
                            this.isNextLevelRewards = true;
                        }
                    }
                    this.globalRallyYear.push(this.getIncentivesGlobalRallyResponse.globalRallyView[i].year);
                }
                this.globalRallyYear.sort((a, b) => b.localeCompare(a));
                this.globalRallyCurrentYear = this.globalRallyYear[0];
                this.getGlobalRallyData(this.globalRallyCurrentYear);
                setTimeout(() => {
                    this.spinnerService.stop(ReportNameConstants.GLOBAL_RALLY);
                }, 0);
            },
                (error: any) => {
                    this.globalRallyError = true;
                    this.handleError(error);
                    setTimeout(() => {
                        this.spinnerService.stop(ReportNameConstants.GLOBAL_RALLY);
                    }, 0);
                }
            );
    }

    /**
     *
     * @description Get year related data from Global Rally Response
     * @param {string} year
     * @memberof IncentivesComponent
     */
    getGlobalRallyData(year: string) {
        this.getGlobalRallyRewards = [];
        this.getGlobalRallyNextLevelRewards = [];
        if (this.getIncentivesGlobalRallyResponse.globalRallyView.length <= 0) {
            this.globalRallyFlag = false;
        } else {
            this.globalRallyFlag = true;
        }
        this.globalRallyCurrentYear = year;
        for (let i = 0; i < this.getIncentivesGlobalRallyResponse.globalRallyView.length; i++) {
            if (this.getIncentivesGlobalRallyResponse.globalRallyView[i].year === this.globalRallyCurrentYear) {
                this.getGlobalRally = this.getIncentivesGlobalRallyResponse.globalRallyView[i];
                if (this.getGlobalRally.rewardsAchieved.length <= 0) {
                    this.isNextRewards = false;
                } else {
                    for (let j = 0; j < this.getGlobalRally.rewardsAchieved.length; j++) {
                        this.getGlobalRallyRewards.push(this.getGlobalRally.rewardsAchieved[j]);
                    }
                    this.isNextRewards = true;
                }
                if (this.getGlobalRally.nextLevelRewards.length <= 0) {
                    this.isNextLevelRewards = false;
                } else {
                    for (let k = 0; k < this.getGlobalRally.nextLevelRewards.length; k++) {
                        this.getGlobalRallyNextLevelRewards.push(this.getGlobalRally.nextLevelRewards[k]);
                    }
                    this.isNextLevelRewards = true;
                }
                if (this.getGlobalRally.currentLevelLabel === ReportNameConstants.CURRRENT_LEVEL) {
                    this.currentLevel = true;
                } else {
                    this.currentLevel = false;
                }
            }
        }

    }

    /**
    * @description  Method to get details of Earned or Forever 2 Drive Incentives
    * @param {string} distributorId
    * @param {string} selectedCountry
    * @param {string} ReportNameConstants.EARNED_FOREVER
    * @memberof IncentivesComponent
    */
    // getEarnedIncentivesData(year: string) {
    //     setTimeout(() => {
    //         this.spinnerService.start(ReportNameConstants.EARNED_FOREVER);
    //     }, 0);
    //     this.earnedIncentivesFlag = true;
    //     this.earnedIncentivesYear = year;
    //     this._incentiveService.getEarnedIncentivesDetails(this._id, this.country,
    //         ReportNameConstants.EARNED_FOREVER, this.earnedIncentivesYear)
    //         .subscribe((data) => {
    //             this.getIncentivesEarnedResponse = data;
    //             this.isEarnedData = true;
    //             this.earnedIncentiveError = false;
    //             this.spinnerService.stop(ReportNameConstants.EARNED_FOREVER);
    //             if (this.getIncentivesEarnedResponse.earnedIncentiveView.length > 0) {
    //                 this.earnedIncentivesFlag = true;
    //                 this.getEarnedIncentives = this.getIncentivesEarnedResponse.earnedIncentiveView[0];
    //             } else {
    //                 this.earnedIncentivesFlag = false;
    //             }
    //             this.firstDisplayMonth = Number(this.getEarnedIncentives.year);
    //             if (this.getEarnedIncentives.earnedIncentiveMonth1Name === ReportNameConstants.NOVEMBER ||
    //                 this.getEarnedIncentives.earnedIncentiveMonth1Name === ReportNameConstants.DECEMBER) {
    //                 this.isYearValid1 = true;
    //             }

    //             if (this.getEarnedIncentives.earnedIncentiveMonth2Name === ReportNameConstants.DECEMBER) {
    //                 this.isYearValid2 = true;
    //             }
    //         },
    //             (error: any) => {
    //                 this.spinnerService.stop(ReportNameConstants.EARNED_FOREVER);
    //                 this.earnedIncentiveError = true;
    //                 this.handleError(error);
    //             }
    //         );
    // }

    getEarnedIncentivesData(year: string, month: number) {
        setTimeout(() => {
          this.spinnerService.start(ReportNameConstants.EARNED_FOREVER);
        }, 0);
        this.earnedIncentivesFlag = true;
        this.earnedIncentivesYear = year;
        this.earnedIncentiveMonth = month;
        if (this.selectedCountry) {
        this._incentiveService.getEarnedIncentivesDetails(this._id, this.operatingCountryName,
          ReportNameConstants.EARNED_FOREVER, this.earnedIncentivesYear, month)
          .subscribe((data) => {
            this.getIncentivesEarnedResponse = data;
            this.isEarnedData = true;
            this.earnedIncentiveError = false;
            this.spinnerService.stop(ReportNameConstants.EARNED_FOREVER);
            if (this.getIncentivesEarnedResponse.earnedIncentiveView.length > 0) {
              this.earnedIncentivesFlag = true;
              this.getEarnedIncentives = this.getIncentivesEarnedResponse.earnedIncentiveView[0];
            } else {
              this.earnedIncentivesFlag = false;
            }
            if (this.getEarnedIncentives) {
              if (!this.getEarnedIncentives.earnedPotentialBonusAmount) {
                this.getEarnedIncentives.earnedPotentialBonusAmount = 0;
              }
              if (this.getEarnedIncentives.earnedIncentiveLevel === 0) {
                this.requiredTotalCC = this.getEarnedIncentives.earnedIncentiveMonth3Level1Required;
              } else if (this.getEarnedIncentives.earnedIncentiveLevel === 1) {
                this.requiredTotalCC = this.getEarnedIncentives.earnedIncentiveMonth3Level2Required;
              } else if (this.getEarnedIncentives.earnedIncentiveLevel >= 2) {
                this.requiredTotalCC = this.getEarnedIncentives.earnedIncentiveMonth3Level3Required;
              }
              this.getTotalCCPercentage();
              this.getCurrentMonthsPercentage();
              this.getPreviousMonthsPercentage();
              this.getPrevious2MonthsPercentage();
            }
            this.firstDisplayMonth = Number(this.getEarnedIncentives.year);
            if (this.getEarnedIncentives.earnedIncentiveMonth1Name === ReportNameConstants.NOVEMBER ||
              this.getEarnedIncentives.earnedIncentiveMonth1Name === ReportNameConstants.DECEMBER) {
              this.isYearValid1 = true;
            }

            if (this.getEarnedIncentives.earnedIncentiveMonth2Name === ReportNameConstants.DECEMBER) {
              this.isYearValid2 = true;
            }
          },
            (error: any) => {
              setTimeout(() => {
                this.spinnerService.stop(ReportNameConstants.EARNED_FOREVER);
              }, 0);
              this.earnedIncentiveError = true;
              this.handleError(error);
            }
          );
        } else {
          setTimeout(() => {
            this.spinnerService.stop(ReportNameConstants.EARNED_FOREVER);
          }, 0);
          this.earnedIncentiveError = true;
        }
      }


        /**
   * @description Calculate Total CC Percentage
   * @date 2020-09-08
   * @memberof IncentivesComponent
   */
  getTotalCCPercentage(): void {
    if (this.getEarnedIncentives.earnedIncentiveMonth3Actual > this.requiredTotalCC) {
      this.totalCCPercentage = 100;
    } else {
      this.totalCCPercentage =
      (this.getEarnedIncentives.earnedIncentiveMonth3Actual  * 100) / this.requiredTotalCC;
    }
  }

  getCurrentMonthsPercentage(): void {
    // Current Month Level1 percentage
    if (this.getEarnedIncentives.earnedIncentiveMonth3Actual > this.getEarnedIncentives.earnedIncentiveMonth3Level1Required) {
      this.currentMonthLevel1Percentage = 100;
    } else {
      this.currentMonthLevel1Percentage =
      (this.getEarnedIncentives.earnedIncentiveMonth3Actual  * 100) / this.getEarnedIncentives.earnedIncentiveMonth3Level1Required;
    }
    // Current Month Level2 Percentage
    if (this.getEarnedIncentives.earnedIncentiveMonth3Actual > this.getEarnedIncentives.earnedIncentiveMonth3Level2Required) {
      this.currentMonthLevel2Percentage = 100;
    } else {
      this.currentMonthLevel2Percentage =
      (this.getEarnedIncentives.earnedIncentiveMonth3Actual  * 100) / this.getEarnedIncentives.earnedIncentiveMonth3Level2Required;
    }
    // Current Month Level3 percentage
    if (this.getEarnedIncentives.earnedIncentiveMonth3Actual > this.getEarnedIncentives.earnedIncentiveMonth3Level3Required) {
      this.currentMonthLevel3Percentage = 100;
    } else {
      this.currentMonthLevel3Percentage =
      (this.getEarnedIncentives.earnedIncentiveMonth3Actual  * 100) / this.getEarnedIncentives.earnedIncentiveMonth3Level3Required;
    }
  }

  /**
   * @description calculate Last Month graph percentage
   * @date 2020-09-08
   * @memberof HomeComponent
   */
  getPreviousMonthsPercentage(): void {
    // previous Month Level1 percentage
    if (this.getEarnedIncentives.earnedIncentiveMonth2Actual > this.getEarnedIncentives.earnedIncentiveMonth2Level1Required) {
      this.previousMonthLevel1Percentage = 100;
    } else {
      this.previousMonthLevel1Percentage =
      (this.getEarnedIncentives.earnedIncentiveMonth2Actual  * 100) / this.getEarnedIncentives.earnedIncentiveMonth2Level1Required;
    }
    // previous Month Level2 Percentage
    if (this.getEarnedIncentives.earnedIncentiveMonth2Actual > this.getEarnedIncentives.earnedIncentiveMonth2Level2Required) {
      this.previousMonthLevel2Percentage = 100;
    } else {
      this.previousMonthLevel2Percentage =
      (this.getEarnedIncentives.earnedIncentiveMonth2Actual  * 100) / this.getEarnedIncentives.earnedIncentiveMonth2Level2Required;
    }
    // previous Month Level3 percentage
    if (this.getEarnedIncentives.earnedIncentiveMonth2Actual > this.getEarnedIncentives.earnedIncentiveMonth2Level3Required) {
      this.previousMonthLevel3Percentage = 100;
    } else {
      this.previousMonthLevel3Percentage =
      (this.getEarnedIncentives.earnedIncentiveMonth2Actual  * 100) / this.getEarnedIncentives.earnedIncentiveMonth2Level3Required;
    }
  }

  /**
   * @description calculate previous 2 months percentage
   * @date 2020-09-08
   * @memberof HomeComponent
   */
  getPrevious2MonthsPercentage(): void {
    // last 2 Month Level1 percentage
    if (this.getEarnedIncentives.earnedIncentiveMonth1Actual > this.getEarnedIncentives.earnedIncentiveMonth1Level1Required) {
      this.previous2MonthLevel1Percentage = 100;
    } else {
      this.previous2MonthLevel1Percentage =
      (this.getEarnedIncentives.earnedIncentiveMonth1Actual  * 100) / this.getEarnedIncentives.earnedIncentiveMonth1Level1Required;
    }
    // last 2 Month Level2 Percentage
    if (this.getEarnedIncentives.earnedIncentiveMonth1Actual > this.getEarnedIncentives.earnedIncentiveMonth1Level2Required) {
      this.previous2MonthLevel2Percentage = 100;
    } else {
      this.previous2MonthLevel2Percentage =
      (this.getEarnedIncentives.earnedIncentiveMonth1Actual  * 100) / this.getEarnedIncentives.earnedIncentiveMonth1Level2Required;
    }
    // last 2 Month Level3 percentage
    if (this.getEarnedIncentives.earnedIncentiveMonth1Actual > this.getEarnedIncentives.earnedIncentiveMonth1Level3Required) {
      this.previous2MonthLevel3Percentage = 100;
    } else {
      this.previous2MonthLevel3Percentage =
      (this.getEarnedIncentives.earnedIncentiveMonth1Actual  * 100) / this.getEarnedIncentives.earnedIncentiveMonth1Level3Required;
    }
  }

    /**
    * @description  Method to get details of Earned or Forever 2 Drive Incentives
    * @param {string} distributorId
    * @param {string} selectedCountry
    * @param {string} ReportNameConstants.EAGLE_MANAGER
    * @memberof IncentivesComponent
    */
   getEagleManagerByYearIncentivesData(year: number) {
    setTimeout(() => {
      this.spinnerService.start(ReportNameConstants.EAGLE_MANAGER);
    }, 0);
    this.eagleManagerFlag = true;

    if (this.displayMonth <= 4) {
      if (year === this.eagleManagerCurrentYear) {
        this.eagleManagersYear = this.eagleManagerCurrentYear;
      } else {
        this.eagleManagersYear = this.eagleManagerCurrentYear - 1;
      }
    } else {
      if (year === this.eagleManagerCurrentYear) {
        this.eagleManagersYear = this.eagleManagerPreviousYear + 1;
      } else {
        this.eagleManagersYear = this.eagleManagerPreviousYear;
      }
    }
    this.eagleManagerCount = 0;
    this._incentiveService.getEagleManagerIncentivesDetails(this._id, this.operatingCountry,
        ReportNameConstants.EAGLE_MANAGER_INCENTIVE, this.eagleManagersYear)
      .subscribe((data) => {
        this.getIncentivesEagleManagerResponse = data;
        this.isEagleManagerData = true;
        this.eagleManagerError = false;
        this.getEagleManagerQualifiers = [];
        this.spinnerService.stop(ReportNameConstants.EAGLE_MANAGER);
        if (this.getIncentivesEagleManagerResponse.eagleManagerView.length > 0) {
          this.eagleManagerFlag = true;
          this.getEagleManagers = this.getIncentivesEagleManagerResponse.eagleManagerView[0];
          this.eagleManagerMonth = this.getEagleManagers.eagleManagersMonth;
          this.eagleManagerCount = this.getEagleManagers.actualEagleManager;
          this.eagleManagerTotalCC = this.getEagleManagers.eagleManagerTotalCC;
          this.eagleManagerGlobalCC = this.getEagleManagers.eagleManagerNewGlobalCC;
          this.isEagleManagerQualified = this.getEagleManagers.isEagleManagerQualified;
             this.getEagleManagerTotalCCChart();
          this.getEagleManagerGlobalCCChart();
          this.displayFBODetails = false;
          this.showEagleManagerDetails();

        } else {
          this.eagleManagerFlag = false;
        }
      },
        (error: any) => {
          this.spinnerService.stop(ReportNameConstants.EAGLE_MANAGER);
          this.eagleManagerError = true;
          this.handleError(error);
        }
      );
  }
    /**
    * @description  Method to show Eagle Manager Details
    * @memberof IncentivesComponent
    */
    showEagleManagerDetails() {
        this.displayFBODetails = false;
    }

    loadAdditionalReportPage(event) {
        let url = null;
        url = this.router.createUrlTree([ 'reports', event.target.id], {
            queryParams: { country: this.operatingCountry , year: this.eagleManagersYear }});
        this._cacheService.set('eagleManagerMonth', this.eagleManagerMonth);
        window.open(url.toString(), '_blank');
      }

      /**
       * @description load eagle manager lines report
       * @date 2020-04-06
       * @param {*} event
       * @memberof HomeComponent
       */
      loadEagleManagerLinesReportPage(event: any) {
        const url = this.router.createUrlTree(['reports', event.target.id], {
          queryParams: {year: this.eagleManagersYear, country: this.operatingCountry }
        });
        this._cacheService.set('eagleManagerMonth', this.eagleManagerMonth);
        window.open(url.toString(), '_blank');
      }

    getEagleManagerTotalCCChart() {
        if (this.eagleManagerTotalCC > 720) {
          this.eagleManagerTotalPercentage = 100;
        } else {
          this.eagleManagerTotalPercentage = (this.eagleManagerTotalCC * 100) / 720;
        }
        setTimeout(() => {
          this.spinnerService.stop(ReportNameConstants.EAGLE_MANAGER);
        }, 0);
      }

      /**
       * get Eagle Manager global CC Chart
       */
      getEagleManagerGlobalCCChart(): void {
        if (this.eagleManagerGlobalCC > 100) {
          this.eagleManagerGlobalPercentage = 100;
        } else {
          this.eagleManagerGlobalPercentage = (this.eagleManagerGlobalCC * 100) / 100;
        }
        setTimeout(() => {
          this.spinnerService.stop(ReportNameConstants.EAGLE_MANAGER);
        }, 0);
      }
    /**
    * @description  Method to show Eagle Manager FBO's
    * @memberof IncentivesComponent
    */
    showEagleManagerFBOs() {
        this.displayFBODetails = true;
        this.getEagleManagerByYearIncentivesData(this.eagleManagersYear);
    }


    /**
    * @description Get Leadership Bonus Incentives Response
    * @memberof IncentivesComponent
    */
    getLeadershipBonusResponse() {
        setTimeout(() => {
            this.spinnerService.start(ReportNameConstants.LEADERSHIP_BONUS);
        }, 0);
        this.leadershipFlag = true;
        this._incentiveService.getIncentivesDetails(this._id, this.operatingCountryName,
            ReportNameConstants.LEADERSHIP_BONUS)
            .subscribe((data) => {
                this.getIncentivesLeadershipBonusResponse = data;
                this.isLeadershipData = true;
                this.leadershipError = false;
                this.leadershipMonth = [];
                if (this.getIncentivesLeadershipBonusResponse.leadershipBonus.length <= 0) {
                    this.leadershipFlag = false;
                } else {
                    this.leadershipFlag = true;
                }
                for (let i = 0; i < this.getIncentivesLeadershipBonusResponse.leadershipBonus.length; i++) {
                    if (this.getIncentivesLeadershipBonusResponse.leadershipBonus[i].month === this.leadershipCurrentMonth) {
                        this.getLeadershipBonus = this.getIncentivesLeadershipBonusResponse.leadershipBonus[i];
                    }
                    this.leadershipMonth.push(this.getIncentivesLeadershipBonusResponse.leadershipBonus[i].month);
                }
                this.leadershipMonth.sort((a, b) => b.localeCompare(a));
                this.leadershipCurrentMonth = this.leadershipMonth[0];
                this.getLeadershipBonusData(this.leadershipCurrentMonth);
                setTimeout(() => {
                    this.spinnerService.stop(ReportNameConstants.LEADERSHIP_BONUS);
                }, 0);
            },
                (error: any) => {
                    setTimeout(() => {
                        this.spinnerService.stop(ReportNameConstants.LEADERSHIP_BONUS);
                    }, 0);
                    this.leadershipError = true;
                    this.handleError(error);
                }
            );
    }

    /**
     * @description  Get month related data from Leadership Bonus Response
     * @param {string} month
     * @memberof IncentivesComponent
     */
    getLeadershipBonusData(month: string) {
        if (this.getIncentivesLeadershipBonusResponse.leadershipBonus.length <= 0) {
            this.leadershipFlag = false;
        } else {
            this.leadershipFlag = true;
        }
        this.leadershipCurrentMonth = month;
        for (let i = 0; i < this.getIncentivesLeadershipBonusResponse.leadershipBonus.length; i++) {
            if (this.getIncentivesLeadershipBonusResponse.leadershipBonus[i].month === this.leadershipCurrentMonth) {
                this.getLeadershipBonus = this.getIncentivesLeadershipBonusResponse.leadershipBonus[i];
            }

        }
    }

    /**
    * @description  Get Chairman's Bonus Incentives Response
    * @memberof IncentivesComponent
    */
    getChairmanBonusResponse() {
        setTimeout(() => {
            this.spinnerService.start(ReportNameConstants.CHAIRMANS_BONUS);
        }, 0);
        this.chairmanBonusFlag = true;
        this._incentiveService.getIncentivesDetailsView(this._id, this.country,
            ReportNameConstants.CHAIRMANS_BONUS)
            .subscribe((data) => {
                this.getIncentivesChairmanBonusResponse = data;
                this.isChairmanData = true;
                this.chairmanBonusError = false;
                if (this.getIncentivesChairmanBonusResponse.chairmanBonusView.length <= 0) {
                    this.chairmanBonusFlag = false;
                } else {
                    this.chairmanBonusFlag = true;
                }

                    this.chairmanBonusYear = [];
                    for (let i = 0; i < this.getIncentivesChairmanBonusResponse.chairmanBonusView.length; i++) {
                        if (this.getIncentivesChairmanBonusResponse.chairmanBonusView[i].year === this.chairmanCurrentYear) {
                            this.getChairmanBonus = this.getIncentivesChairmanBonusResponse.chairmanBonusView[i];
                        }
                        this.chairmanBonusYear.push(this.getIncentivesChairmanBonusResponse.chairmanBonusView[i].year);
                    }

                    this.chairmanBonusYear.sort((a, b) => b.localeCompare(a));
                    this.chairmanCurrentYear = this.chairmanBonusYear[0];

                this.getChairmanBonusIncentivesData(this.chairmanCurrentYear);
                setTimeout(() => {
                    this.spinnerService.stop(ReportNameConstants.CHAIRMANS_BONUS);
                }, 0);
            },
                (error: any) => {
                    setTimeout(() => {
                        this.spinnerService.stop(ReportNameConstants.CHAIRMANS_BONUS);
                    }, 0);
                    this.chairmanBonusError = true;
                    this.handleError(error);
                }
            );
    }

    /**
     * @description Get year related data from Chairman Bonus Response
     * @param {string} year
     * @memberof IncentivesComponent
     */
    getChairmanBonusIncentivesData(year: string) {
        this.getChairmanBonusQualifiers = [];
        if (this.getIncentivesChairmanBonusResponse.chairmanBonusView.length <= 0) {
            this.chairmanBonusFlag = false;
        } else {
            this.chairmanBonusFlag = true;
        }
        this.chairmanCurrentYear = year;
        for (let i = 0; i < this.getIncentivesChairmanBonusResponse.chairmanBonusView.length; i++) {
            if (this.getIncentivesChairmanBonusResponse.chairmanBonusView[i].year === this.chairmanCurrentYear) {
                this.getChairmanBonus = this.getIncentivesChairmanBonusResponse.chairmanBonusView[i];
            }
        }
        for (let j = 0; j < this.getChairmanBonus.myCBQualifiers.length; j++) {
            this.getChairmanBonusQualifiers.push(this.getChairmanBonus.myCBQualifiers[j]);
        }
            this.showChairmanBonusDetails();
    }

    /**
    * @description  Method to show Chairman Bonus FBO's
    * @memberof IncentivesComponent
    */
    showChairmanBonusFBOs() {
        this.displayChairmanBonus = true;
        this.getChairmanBonusResponse();
    }

    /**
    * @description Method to show details of Chairman Bonus Incentives
    * @memberof IncentivesComponent
    */
    showChairmanBonusDetails() {
        this.displayChairmanBonus = false;
    }

    /**
    * @description  Method to get details of Gem Bonus Incentives
    * @memberof IncentivesComponent
    */
    getGemBonusReponse() {
        setTimeout(() => {
            this.spinnerService.start(ReportNameConstants.GEM_BONUS);
        }, 0);
        this.gemBonusFlag = true;
        this._incentiveService.getIncentivesDetailsView(this._id, this.operatingCountryName,
            ReportNameConstants.GEM_BONUS)
            .subscribe((data) => {
                this.getIncentivesGemBonusResponse = data;
                this.isGemBonusData = true;
                this.gemBonusError = false;
                this.firstGenerationGemDetails = [];
                this.silverCCGemManager = [];
                if (this.getIncentivesGemBonusResponse.gemBonus.length <= 0) {
                    this.gemBonusFlag = false;
                } else {
                    this.gemBonusFlag = true;
                }
                    this.gemBonusMonth = [];
                    for (let i = 0; i < this.getIncentivesGemBonusResponse.gemBonus.length; i++) {
                        if (this.getIncentivesGemBonusResponse.gemBonus[i].month === this.gemBonusCurrentMonth) {
                            this.getGemBonus = this.getIncentivesGemBonusResponse.gemBonus[i];
                        }
                        this.gemBonusMonth.push(this.getIncentivesGemBonusResponse.gemBonus[i].month);
                    }
                    this.gemBonusMonth.sort((a, b) => b.localeCompare(a));
                    this.gemBonusCurrentMonth = this.gemBonusMonth[0];
                this.getGemBonusIncentivesData(this.gemBonusCurrentMonth);
                setTimeout(() => {
                    this.spinnerService.stop(ReportNameConstants.GEM_BONUS);
                }, 0);
            },
                (error: any) => {
                    setTimeout(() => {
                        this.spinnerService.stop(ReportNameConstants.GEM_BONUS);
                    }, 0);
                    this.gemBonusError = true;
                    this.handleError(error);
                }
            );
    }

    /**
     * @description Retrives month specific data from Gem Bonus Response
     * @param {string} month
     * @memberof IncentivesComponent
     */
    getGemBonusIncentivesData(month: string) {
        this.firstGenerationGemDetails = [];
        if (this.getIncentivesGemBonusResponse.gemBonus.length <= 0) {
            this.gemBonusFlag = false;
        } else {
            this.gemBonusFlag = true;
        }
        this.gemBonusCurrentMonth = month;
        for (let i = 0; i < this.getIncentivesGemBonusResponse.gemBonus.length; i++) {
            if (this.getIncentivesGemBonusResponse.gemBonus[i].month === this.gemBonusCurrentMonth) {
                this.getGemBonus = this.getIncentivesGemBonusResponse.gemBonus[i];
                if (this.getGemBonus.numberOfFirstGenerationActiveRecognizedManagers === 0 &&
                    this.getGemBonus.numberOfDownlineManagers25CC === 0) {
                    this.gemBonusFlag = false;
                }
            }

        }
        for (let j = 0; j < this.getGemBonus.gemFirstGenARMs.length; j++) {
            this.firstGenerationGemDetails.push(this.getGemBonus.gemFirstGenARMs[j]);
        }
        for (let k = 0; k < this.getGemBonus.gem25CCManagers.length; k++) {
            this.silverCCGemManager.push(this.getGemBonus.gem25CCManagers[k]);
        }
            this.showGemBonusDetails();
    }

    /**
    * @description  Method to show Gem Bonus First Manager
    * @memberof IncentivesComponent
    */
    showFirstGemManager() {
        this.displayFirstGemManager = true;
        this.displaySilverGemManager = false;
        this.getGemBonusReponse();
    }

    /**
     * @description  Method to show Gem Bonus 25CC Manager
     * @memberof IncentivesComponent
     */
    showSilverGemManager() {
        this.displayFirstGemManager = false;
        this.displaySilverGemManager = true;
        this.getGemBonusReponse();
    }

    /**
     * @description  Method to show details of Gem Bonus Incentives
     * @memberof IncentivesComponent
     */
    showGemBonusDetails() {
        this.displayFirstGemManager = false;
        this.displaySilverGemManager = false;
    }

    /**
    * @description handles errors from server and from lack of data
    * @param {*} error
    * @returns {void}
    * @memberof IncentivesComponent
    */
    handleError(error): void {
        this.isServerError = true;
        return error;
    }

    navigateToEagleManagerSummaryCountry() {
        let url = null;
        this._cacheService.set("agleManagerCountryDisplayName", this.countryDisplayName);
        url = this.router.createUrlTree(['reports', 'eagle-manager-cc-summary-by-country'], {
          queryParams: {year: this.eagleManagersYear }
        });
        // window.open(url.toString(), '_blank');
      }

      /**
       * @description show check box field
       * @date 2020-05-01
       * @returns {boolean}
       * @memberof IncentivesComponent
       */
      showCheckBox(): boolean {
        if (this.eagleManagerTotalCC >= 720 || this.eagleManagerGlobalCC >= 100
           || (this.getEagleManagers && this.getEagleManagers.numberOfNewSupervisors >= 2)) {
          return true;
        }
      }

    /**
     * @description Get Member level
     * @date 2020-08-28
     * @param {number} level
     * @returns {string}
     * @memberof FBOProfileComponent
     */
    getMemberLevel(level: number): string {
        return MemberTitleExtEnums[level] ? MemberTitleExtEnums[level].replace('_', ' ') : '';
    }

    /**
     * To Save Member activity log to show flp360 Reports
     */
    saveMemberActivityLog(): void {
        const activityLogKeys: ActivityLogKey[] = [{
            key: MemberActivityLogType.Flp360_Impersonation_Started,
            value: this.fboid
        }];
        this._commonService.saveMemberActivity(+this.fboid, activityLogKeys).subscribe();
    }

    /**
     * Frame the incentives url to load from FLP360 web
     */
    getFLP360ReportURL(reportName) {
        let flp360BaseURL = environment.flp360BaseURL;
        let requestedURL = null;
        let opco = null;
        if(this.operatingCountryName === IsoCodeThree.ESP || this.operatingCountryName === IsoCodeThree.PRT){
            opco = IsoCodeThree.FRA;
        }else{
            opco = this.operatingCountryName;
        }
        if(reportName === FLP360ReportNameConstants.INCENTIVES){

            requestedURL = flp360BaseURL + ReportPathConstants.INCENTIVE_URL + "?fboId=" + this.fboid
                                + "&homeCountry=" + this.homeCountry + "&operatingCountry=" + opco;
}
        return requestedURL;
    }

    /**
     * Apply iframe styles once its properly loaded in DOM
     */
    applyIframeStyles(){
        setTimeout(() => {
            const iframe: any = document.querySelector('#incentives'+this.fboid);
            const spin : any = document.querySelector('#spinner'+this.fboid);
            if(iframe){
                iframe.style.visibility='visible';
                iframe.style.height='750px';
                spin.style.display='none';
            }
        }, 3000);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/incentives.component.ts